import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { IParamsCreateCode } from '../../../../shared/models/ApplicationUser';
import { EventInteraction, GTMInteractions } from '../../../../shared/models/Constants';
import { AnalyticsService } from '../../../../shared/services/analytics.service';
import { EncryptionService } from '../../../../shared/services/encryption/encryption.service';
import { SharedServiceService } from '../../../../shared/services/shared-service.service';

@Component({
  selector: 'app-input-sms',
  templateUrl: './input-sms.component.html',
  styleUrls: ['./input-sms.component.scss'],
})
export class InputSmsComponent implements OnInit, OnDestroy {

  @Input() ListButtonsCode = `calc(${window.innerHeight > 895 ? 896 : window.innerHeight}px - 470px)`;
  @Input() codeForm: UntypedFormGroup; // Formulario de código SMS
  @Input() spinner = false;
  @Input() spinnerSendSms = false;
  @Input() smsCountDown: { countdown: number; time: string; } = { countdown: 0, time: '' };

  @Output() preveNumber = new EventEmitter<boolean>();
  @Output() submitCode = new EventEmitter<string>();
  @Output() sendNumber = new EventEmitter<IParamsCreateCode>();

  public numero = '';
  public telefono: number = null;

  private finishSubscriptions: Subject<boolean> = new Subject();

  constructor(
    private sharedS: SharedServiceService
    , private analytService: AnalyticsService
    , private ruta: ActivatedRoute
    , private encryptionS: EncryptionService
  ) { }

  ngOnInit() {
    this.formatter();
  }

  async ngOnDestroy() {
    this.finishSubscriptions.next(true);
    this.finishSubscriptions.complete();
  }

  private formatter() {
    this.sharedS.numeroTelefonico
      .pipe(takeUntil(this.finishSubscriptions))
      .subscribe(numero => {
        if (numero !== null) {
          this.telefono = numero;
          this.numero = numero.toString().substring(0, 2) + ' ' + numero.toString().substring(2, 6)
            + ' ' + numero.toString().substring(6, 11);
        }
      })
  }

  public onSubmitTemplate = () => {
    this.codeForm.get('codigo').setValue(this.codeForm.get('codigo').value.toString().trim());
    if (this.codeForm.invalid) { return; }
    this.submitCode.next(this.codeForm.get('codigo').value);
  }

  public prevNumber() {
    if (this.ruta.snapshot.params.slide === 'recuperacion') {
      this.analytService.sendEventAnalytics(GTMInteractions.recoveryPhoneEditEvent, EventInteraction)
    } else {
      this.analytService.sendEventAnalytics(GTMInteractions.registerPhoneEditEvent, EventInteraction)
    }

    this.codeForm.get('codigo').setValue('');
    this.preveNumber.emit(true)
  }

  public sendCodeNew = (telefono: number) => this.sendNumber.next({ Telefono: this.encryptionS.encrypt(telefono.toString()) });

}
